export default __webpack_public_path__ + "static/benifitImage-637166a3cd2ff5751b412f28606b0777.png";